import PropTypes from 'prop-types';
import { useMemo } from 'react';
import ContextProviderUtilities from './ContextProviderUtilities';

const [useContext, Provider] = ContextProviderUtilities();

const useRecordContext = useContext;

export const RecordContextProviderUtilities = ({ children, id, type }) => {
    const contextValue = useMemo(() => ({ id, type }), [id, type]);
    return <Provider value={contextValue}>{children}</Provider>;
};

RecordContextProviderUtilities.propTypes = {
    children: PropTypes.node,
    id: PropTypes.string,
    type: PropTypes.string,
};

RecordContextProviderUtilities.defaultProps = {
    children: null,
    id: '',
    type: '',
};

export default useRecordContext;
